/* unplugin-vue-components disabled */import { render } from "./collectionCorrection.vue?vue&type=template&id=67bbc2aa&scoped=true&ts=true"
import script from "./collectionCorrection.vue?vue&type=script&lang=ts"
export * from "./collectionCorrection.vue?vue&type=script&lang=ts"

import "./collectionCorrection.vue?vue&type=style&index=0&id=67bbc2aa&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bbc2aa"]])

export default __exports__